import { Location } from '@angular/common';
import { Content } from '@angular/compiler/src/render3/r3_ast';
import {
  AfterViewInit,
  Component,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { AuthenticationService, ContentService, Device, DeviceService, MessageDialog, User, UserService, UserUsage } from '../../shared';
import { ChangePassword } from '../header-nav/change-password.component';

declare let mLayout: any;
@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-header-nav',
  styleUrls: ['../../eacds/devices/devices.css'],
  templateUrl: './header-nav.component.html',
})
export class HeaderNavComponent implements OnInit, AfterViewInit {
  public user: User;
  public route: string;
  public searchInput: string;
  public results: { devices: Device[], contents: Content[] };

  public timeoutSearch;
  public diskUsage: UserUsage;

  constructor(
    private router: Router,
    private userService: UserService,
    private contentService: ContentService,
    private deviceService: DeviceService,
    private location: Location,
    private authService: AuthenticationService,
    public dialog: MatDialog,
  ) { }

  public ngOnInit() {
    this.user = this.authService.getCurrentUserCookie();
    this.userService.getUserDiskUsage().subscribe((diskUsage: UserUsage) => {
      this.diskUsage = diskUsage;
    });
    this.router.events.subscribe((val) => {
      if (this.location.path() !== '') {
        this.route = this.location.path();
      } else {
        this.route = 'Home';
      }
    });
  }

  public ngAfterViewInit() {
    mLayout.initHeader();
  }

  public changePassword(): void {
    const dialogRef = this.dialog.open(ChangePassword, {
      width: '700px',
      data: { user: this.user._id },
    });

    dialogRef.afterClosed().subscribe((result) => { });
  }

  public seeUserDetails(userId) {
    this.router.navigate(['/userAcc/' + userId + '/details']);
  }
  public onMyUsageInfo() {
    if (this.diskUsage.usedPerc >= 100) {
      this.dialog.open(MessageDialog, { data: { title: 'Disk quota exceeded', message: this.diskUsage.message } });
    }
  }
  public fastSearch() {
    if (!this.searchInput) { return; }
    this.results = { devices: [], contents: [] };
    this.contentService.getAll(0, 10, { name: this.searchInput }).subscribe((result) => {
      this.results.contents = result.contents;
      this.deviceService.getAll(0, 10, { search: this.searchInput }).subscribe((data) => {
        this.results.devices = data.devices;
      });
    });
  }
  public onResultSelected(res) {
    if (res.folderId) {
      // its a content
      this.router.navigate(['/contents/' + res._id + '/details']);
    } else {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/devices/' + res._id + '/details']);
      });
    }
  }
  public search(event) {
    if (!this.searchInput) { return this.results = null; }
    if (event && event.keyCode == 13) {
      clearTimeout(this.timeoutSearch);
      this.fastSearch();
      return;
    }

    if (this.timeoutSearch) {
      clearTimeout(this.timeoutSearch);
    }
    this.timeoutSearch = setTimeout(() => { this.fastSearch(); }, 500);
  }

  public displayFn(res) {
    return res && res.name ? res.name : '';
  }
}
